import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCropPdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#1BCFC4" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.667 8h3.2c.746 0 1.12 0 1.405.145.25.128.455.332.583.583.145.285.145.659.145 1.405v3.2M5.333 8H8m8 8v2.667M18.667 16h-8.534c-.746 0-1.12 0-1.405-.145a1.33 1.33 0 0 1-.583-.583C8 14.987 8 14.613 8 13.867V5.333"
    />
  </svg>
);
export default SvgCropPdf;
